import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeDefaultSelection()
  }

  initializeDefaultSelection() {
    this.disableAllCheckoutButtons()

    const premiumPackage = this.element.querySelector('[data-package-type="premium"]')
    const firstPremiumOption = premiumPackage.querySelector('.price-option:first-child')

    if (firstPremiumOption) {
      this.selectPackage(premiumPackage, firstPremiumOption)
    }
  }

  selectOption(event) {
    const clickedOption = event.currentTarget
    const packageCard = clickedOption.closest('.bg-white.rounded-3xl')

    if (packageCard.classList.contains('selected-package')) {
      this.updateOptionInPackage(packageCard, clickedOption)
    } else {
      this.selectPackage(packageCard, clickedOption)
    }
  }

  selectPackage(packageCard, option) {
    this.deselectAllPackages()
    packageCard.classList.add('selected-package')
    this.updateOptionInPackage(packageCard, option)
    this.enableCheckoutButton(packageCard)
  }

  updateOptionInPackage(packageCard, clickedOption) {
    const packageType = clickedOption.getAttribute('data-package')

    packageCard.querySelectorAll(`[data-package="${packageType}"]`).forEach(option => {
      option.classList.remove('active')
    })

    clickedOption.classList.add('active')
  }

  deselectAllPackages() {
    this.element.querySelectorAll('.bg-white.rounded-3xl').forEach(packageCard => {
      packageCard.classList.remove('selected-package')
    })

    this.element.querySelectorAll('.price-option').forEach(option => {
      option.classList.remove('active')
    })

    this.disableAllCheckoutButtons()
  }

  enableCheckoutButton(packageCard) {
    const checkoutButton = packageCard.querySelector('button[data-action="click->home#proceedToCheckout"]')
    if (checkoutButton) {
      checkoutButton.disabled = false
      checkoutButton.classList.remove('opacity-50', 'cursor-not-allowed')
      checkoutButton.classList.add('hover:bg-ps-green-600')
    }
  }

  disableAllCheckoutButtons() {
    this.element.querySelectorAll('button[data-action="click->home#proceedToCheckout"]').forEach(button => {
      button.disabled = true
      button.classList.add('opacity-50', 'cursor-not-allowed')
      button.classList.remove('hover:bg-ps-green-600')
    })
  }

  proceedToCheckout(event) {
    const button = event.currentTarget
    const packageCard = button.closest('.bg-white.rounded-3xl')
    const selectedOption = packageCard.querySelector('.price-option.active')

    // The chosen row carries its package's checkout (or sign-up) address.
    const url = selectedOption?.dataset.checkoutUrl
    if (url) window.location.href = url
  }
}
